import {
  BehaviorConfig,
  ConditionGroup,
} from 'src/graphql/entities/behavior';

export interface OncallManagementScheduleMutationRecord {
  id: string;
  oncallManagementScheduleId: string;
  createdAt: string;
  startTime: string;
  endTime: string;
  recurrence: string;
  recurrenceUntil?: string | null;
  updatedAt: string;
  primaryAgentId: string;
  secondaryAgentId: string;
  partnerId: string;
}

export interface OncallManagementScheduleRecord {
  id: string;
  oncallManagementScheduleId: string;
  createdAt: string;
  startTime: string;
  endTime: string;
  recurrence: string;
  recurrenceUntil?: string | null;
  updatedAt: string;
  primaryAgent: {
    id: string;
    firstName: string;
    lastName: string;
  };
  secondaryAgent: {
    id: string;
    firstName: string;
    lastName: string;
  } | null;
  partner: {
    id: number;
    partnerId: number;
  };
  conditions?: ConditionGroup;
}
export interface GetOncallManagementScheduleQuery {
  getOncallManagementSchedule: {
    records: OncallManagementScheduleRecord[];
  };
}
export interface OncallManagementScheduleDataInput {
  oncallManagementScheduleId: string;
  partnerId: number;
  startTime: string;
  endTime: string;
  recurrence: string;
  recurrenceUntil?: string | null;
  primaryAgentId: string;
  secondaryAgentId: string | null;
  conditions?: string;
}
export enum RecurrenceOptions {
  Once = 'once',
  Weekly = 'RRULE:FREQ=WEEKLY;INTERVAL=1;WKST=SU',
  Every2Weeks = 'RRULE:FREQ=WEEKLY;INTERVAL=2;WKST=SU',
  Every3Weeks = 'RRULE:FREQ=WEEKLY;INTERVAL=3;WKST=SU',
  Monthly = 'RRULE:FREQ=MONTHLY;INTERVAL=1;WKST=SU',
  Custom = 'custom',
}

export enum EditRecurrence {
  This = 'this',
  ThisAndFollowing = 'all',
}

export enum DeleteRecurrence {
  This = 'this',
  ThisAndFollowing = 'all',
}

export type SignalRulesConfig = Omit<BehaviorConfig, 'triggers' | 'actions' | 'actionTypes'>;
